import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { downloadRollNos_PDF } from "./DownloadRollNos_PDF";
import { exportRollNoListingExcel } from "./DownloadRollNos_Excel";

const List_Roll_Numbers = () => {

  const [selectedYear1, setSelectedYear1] = useState();
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [selectedStd, setSelectedStd] = useState();
  const [ddlStds, setDdlStds] = useState([]);
  const [selectedDiv, setSelectedDiv] = useState();
  const [ddlDivisions, setDdlDivisions] = useState([]);

  const [instituteName, setInstituteName] = useState();

  const [reportData, setReportData] = useState([]);
  const [summReportData, setSummReportData] = useState([]);

  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {

    try {

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);

      setSelectedYear1(year_result.data[0].year1);

      const std_result = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
      setDdlStds(std_result.data);

    } catch (err) {

      console.error("Error loading Dropdowns", err);

    }

  };

  /// To Populate Division on change of Standard
  useEffect(() => {

    const fetchDivision = async () => {
      try {
        setDdlDivisions([]);
        if (selectedStd) {
          const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: selectedStd } });
          setDdlDivisions(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchDivision();

  }, [selectedStd]);

  // Fetch report
  const handleRunReport = async () => {

    if (!selectedYear1 || selectedYear1 === '') {
      toast.error("Please select Academic Year.");
      return;
    } else if (!selectedStd || selectedStd === '') {
      toast.error("Please select Standard.");
      return;
    } else if (!selectedDiv || selectedDiv === '') {
      toast.error("Please select Division.");
      return;
    }

    try {
      setReportData([]);
      const res = await axios.get(`${BASE_URL}/api/rpt_roll_no_listing`, {
        params: {p_year1: selectedYear1, p_std_id: selectedStd, p_div_id: selectedDiv }
      });

      if (res.data.rollNoData.length > 0) {
        setReportData(res.data.rollNoData);
        setSummReportData(res.data.houseSummary);
        setInstituteName(res.data.rollNoData[0].school_name);
      } else {
        setReportData([]);
        toast.error("No Records Found");
      }
    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }
  };

  const selectedStdName = ddlStds.find(std => std.std_id === Number(selectedStd))?.std_name || "";
  const selectedDivName = ddlDivisions.find(div => div.div_id === Number(selectedDiv))?.div_name || "";

  const handleDownloadPDF = () => {

    if (reportData.length === 0) {
      toast.error("No data to download");
      return;
    }

    downloadRollNos_PDF({
      reportData,
      summReportData,
      instituteName,
      selectedYear1,
      selectedStdName,
      selectedDivName,
    });

  };

  const handleDownloadExcel = () => {

    if (reportData.length === 0) {
      toast.error("No data to download");
      return;
    }

    exportRollNoListingExcel({
      reportData,
      summReportData,
      instituteName,
      selectedYear1,
      selectedStdName,
      selectedDivName,
    });

  };

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">

        <Row>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>Academic Year
              </InputGroup.Text>
              <select className="form-select" name="selectedYear1" value={selectedYear1}
                onChange={(e) => setSelectedYear1(e.target.value)} >
                <option value="">--Select Acadamic Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Standard
              </InputGroup.Text>
              <select className="form-select"
                name="selectedStd" value={selectedStd} onChange={(e) => setSelectedStd(e.target.value)} >
                <option value="">--Select Standard--</option>
                {ddlStds.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>

            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>Div
              </InputGroup.Text>
              <select className="form-select" name="selectedDiv"
                value={selectedDiv} onChange={(e) => setSelectedDiv(e.target.value)} >
                <option value="">-- Select Division --</option>
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}
              </select>
            </InputGroup>

          </Col>

         <Col md={4}>
            <Button variant="primary" className="ms-2" disabled={reportData.length === 0}
              onClick={handleDownloadPDF} > Download PDF
            </Button>
            <Button variant="warning" className="ms-2" onClick={handleDownloadExcel}
              disabled={reportData.length === 0}> Download Excel
            </Button>
            <Button variant="success" onClick={handleRunReport} className="ms-2"> Run Report
            </Button>         
         </Col>

        </Row>

        {/* <Row className="mt-3">

          <Col md={12} className="d-flex justify-content-end">
            <Button variant="primary" className="ms-2"
              disabled={reportData.length === 0}
              onClick={handleDownloadPDF}
              >
              Download PDF
            </Button>
            <Button variant="warning" className="ms-2"
              onClick={handleDownloadExcel}
              disabled={reportData.length === 0}>
              Download Excel
            </Button>
            <Button variant="success" onClick={handleRunReport} className="ms-2">
              Run Report
            </Button>          
          </Col>
        </Row> */}

      </Card>

      {/* Report Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'center', width: '9%' }} >Roll No</th>
                <th style={{ textAlign: 'center', width: '8%' }} >GR No. </th>
                <th style={{ textAlign: 'left', width: '48%' }} >Student Name <br/> Address</th>
                <th style={{ textAlign: 'center', width: '12%' }} >Birth Date<br/> Student Id </th>
                <th style={{ textAlign: 'center', width: '8%' }} >Gender</th>
                <th style={{ textAlign: 'center', width: '8%' }} >House</th>
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 ? (
                reportData.map((n, idx) => (
                  <tr key={n.irn}>
                    <td style={{ textAlign: 'center' }}> {n.roll_no} </td>
                    <td style={{ textAlign: 'center' }}> {n.gr_no} </td>
                    <td style={{ textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }} >
                       {n.stud_name} <br/> {n.stud_addr1} <br/> {n.stud_addr2}
                    </td>
                    <td style={{ textAlign: 'center' }}> {n.birth_date} <br/> {n.stud_id} </td>
                    <td style={{ textAlign: 'center' }}> {n.gender} </td>
                    <td style={{ textAlign: 'center' }}> {n.house} </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* House Summary  */}
        <div style={{ minHeight: '220px' }} className="mt-3">
          <p><b>House Summary</b></p>
          <table className="summary-table scty-custom-table-rcpt hover-table-rcpt"
              style={{ maxHeight: '35px', width: "25%", marginLeft: 0 }} >
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'left', width: '12%' }} >House</th>
                <th style={{ textAlign: 'center', width: '6%' }} >Count</th>
              </tr>
            </thead>
            <tbody>
              {summReportData.length > 0 ? (
                summReportData.map((n, idx) => (
                  <tr key={n.irn}>
                    <td style={{ textAlign: 'left' }}> {n.house} </td>
                    <td style={{ textAlign: 'right' }}> {n.stud_count} </td>
                  </tr>
                ))
               ) : (
                <tr>
                  <td colSpan="2" className="text-center">
                    No Data
                  </td>
                </tr>
              )} 
            </tbody>
          </table>
        </div>

      </Card>

    </Container>
  );
};

export default List_Roll_Numbers;
